import { render, staticRenderFns } from "./onDrop.vue?vue&type=template&id=2152afc0"
import script from "./onDrop.vue?vue&type=script&lang=js"
export * from "./onDrop.vue?vue&type=script&lang=js"
import style0 from "./onDrop.vue?vue&type=style&index=0&id=2152afc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports